module.exports = __webpack_public_path__ + "static/media/aasu (2).0cf345fa.png";